import CurrentRequestCard from "../CurrentRequestCard/CurrentRequestCard";
import IndividualCoefficientsModal from "../IndividualCoefficientsModal/IndividualCoefficientsModal";

import ErrorModal from "../../../Modal/ModalConditions/Profile/ErrorModal/ErrorModal";
import SwitchRequests from "../../../SwitchRequests/SwitchRequests";
import RecruitmentToWorkOnHolidaysModal
    from "../../../../pages/HRServicesPage/LeaderRequestsPage/LRPage/RecruitmentToWorkOnHolidaysModal/RecruitmentToWorkOnHolidaysModal";


import StageValidationHOC from "../../../../../hocs/StageValidation.HOC";
import {
    getStructureTopThunkAction,
} from "../../../../../redux/actions/Requests/LeaderRequests/thunk/getStructureTop.thunk.action";
import {
    unsetCurrentDocumentAction,
} from "../../../../../redux/actions/Requests/CurrentRequest/setCurrentDocument.action";
import {
    getUserRequestsThunkAction,
} from "../../../../../redux/actions/Requests/GetUserRequests/thunk/getUserRequests.thunk.action";
import ApproveRequest from "../../Applications/Modal/ApproveRequest/ApproveRequest";
import ModalSuccess
    from "../../../../pages/HRServicesPage/LeaderRequestsPage/LRPage/RecruitmentToWorkOnHolidays/ModalSuccess/ModalSuccess";
import LocalTripDetailModal from "../LocalTripDetailModal/LocalTripDetailModal";
import EmployeesListContext
    from "../../../../pages/HRServicesPage/LeaderRequestsPage/LRPage/RecruitmentToWorkOnHolidaysModal/EmployeesListContext/EmployeesListContext";

import { mode } from "../../../../../app/mode";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { ClipLoader } from "react-spinners";
import React from "react";
import { useContext } from "react";


function UserRequestCard(props) {
    const dispatch = useDispatch();
    const currentRequest = useSelector((state) => state.requests.singleDocument);
    const [reject, setReject] = useState(null);


    console.log(currentRequest);
    console.log(currentRequest && currentRequest.currentRequestCard["Наименование"]);

    //rvd
    const [stageModalWindow, setStageModalWindow] = useState(false);
    const requests = useSelector((state) => state.requests);

    const [sendButtonLoading, setSendButtonLoading] = useState(false);

    const [selectedE, setSelectedE] = useState([]);

    const approveRequest = {
        back: () => {
            setStageModalWindow(null);
            props.close();
        },
        next: async (newTuple, props) => {
            try {
                // const response = await $api.post("v1/auth/verify/password", { password: password.password });
                // console.log("data:  ", response.data);
                newTuple[0][0].props.description = {
                    head: "Служебная записка принята",
                    subHead: " Служебная записка\n" +
                        "                               на тему  «Привлечение к\n" +
                        "                                работе в выходные\n" +
                        "                                и\n" +
                        "                                праздничные дни»\n" +
                        "                                принята.",
                };
                setStageModalWindow(StageValidationHOC(newTuple));
            } catch (e) {

            }
        },
        props: {
            pids: selectedE,


        },
    };
    const actionsOK = {
        back: () => {
            console.log("BACK");
            setStageModalWindow(null);
            props.close();

            dispatch(getStructureTopThunkAction());
            dispatch(
                getUserRequestsThunkAction({
                    page: {
                        pageSize: requests?.userRequests?.pageSize,
                        pageNumber: requests?.userRequests?.pageNumber,
                    },
                }),
            );

        },
        next: (newTuple) => {
            console.log("NEXT", newTuple);
            // dispatch(sendMemoThunkAction());
            // newTuple[1][0].props.name = "NEW HOC";
            // setStageModalWindow(StageValidationHOC(newTuple));
        },
        props: {
            name: "testHOC",
            pids: selectedE,


        },
        // newTuple: null,xx
    };
    const testHOC = StageValidationHOC([
        [approveRequest, ApproveRequest],
        [actionsOK, ModalSuccess],
        // [actionsOK, ModalSuccess],


    ]);
    //rvd


    useEffect(() => {
        return () => {
            props.setDescription(false);
            dispatch(unsetCurrentDocumentAction());

            // clearSelectedToggle();
            setSelectedE([]);
            dispatch(getStructureTopThunkAction());
            dispatch(
                getUserRequestsThunkAction({
                    page: {
                        pageSize: requests?.userRequests?.pageSize,
                        pageNumber: requests?.userRequests?.pageNumber,
                    },
                }),
            );

        };
    }, []);
    console.log(currentRequest && currentRequest.currentRequestCard &&
    currentRequest.currentRequestCard.typeText ? currentRequest.currentRequestCard.typeText :
        "Заявка");
    return (
        stageModalWindow ? stageModalWindow :
            <>
                {props.description ?
                    <ErrorModal
                        description={props.description}
                        setError={props.close}
                    />
                    :( currentRequest ?
                        <div className="request-modal">
                            <SwitchRequests
                                setDescription={props.setDescription}
                                leaveReasonTypeId={
                                    currentRequest && currentRequest.currentRequestCard["Наименование"]}
                                isLeader={props.isLeader}
                                userRequests={props.userRequests}
                                currentRequest={currentRequest && currentRequest.currentRequest}
                                reject={reject}
                                typeText={ currentRequest && currentRequest.currentRequestCard &&
                                    props.isLeader ? currentRequest.currentRequest.entityType.name :
                                    currentRequest.currentRequestCard.typeText
                                }
                                // fullName={currentRequest.currentRequest.initiator}
                                number={
                                    currentRequest &&  currentRequest.currentRequest.orderNumber ? currentRequest.currentRequest.orderNumber : (currentRequest.currentRequest.number ? currentRequest.currentRequest.number : "")
                                }
                            />
                            {
                                currentRequest.currentRequest && currentRequest.currentRequest.leaveTypeId ?


                                    <CurrentRequestCard
                                        isLeader={props.isLeader}
                                        setDescription={props.setDescription}
                                        description={props.description}
                                        userRequests={props.userRequests}
                                        close={props.close} />

                                    :
                                    currentRequest.currentRequest.requestTypeId === 22 ?

                                        <IndividualCoefficientsModal
                                            isLeader={props.isLeader}
                                            setDescription={props.setDescription}
                                            userRequests={props.userRequests}
                                            close={props.close} />

                                        :
                                        currentRequest.currentRequest.entityType?.code === "local-trip"  ?
                                        // <div>work1</div>
                                            <LocalTripDetailModal
                                                isLeader={props.isLeader}
                                                setDescription={props.setDescription}
                                                description={props.description}
                                                userRequests={props.userRequests}
                                                close={props.close}
                                            />

                                            :
                                            <>



                                                {stageModalWindow ? stageModalWindow :
                                                    <RecruitmentToWorkOnHolidaysModal
                                                        // clickHandlerReferences={props.clickHandlerReferences}
                                                        selectedE={selectedE}
                                                        setSelectedE={setSelectedE}
                                                        setStageModalWindow={setStageModalWindow}
                                                        testHOC={testHOC}
                                                        close={props.close}
                                                        // setModalStatus={props.setModalStatus}
                                                    />}


                                            </>


                            }

                            {/*{mode === "UNSTABLE" ?*/}
                            <>
                                {stageModalWindow}
                            </>
                            {/*//     : null*/}
                            {/*// }*/}
                        </div> :  (<div className="request-modal-loader">
                            <ClipLoader color="#6DCDF6" />
                        </div>)
                    )
                }

            </>
    );
}

export default UserRequestCard;
